import { render, staticRenderFns } from "./nfc-scan-success-dialogue.vue?vue&type=template&id=2ed48bec&scoped=true&"
import script from "./nfc-scan-success-dialogue.vue?vue&type=script&lang=js&"
export * from "./nfc-scan-success-dialogue.vue?vue&type=script&lang=js&"
import style0 from "./nfc-scan-success-dialogue.vue?vue&type=style&index=0&id=2ed48bec&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ed48bec",
  null
  
)

export default component.exports